var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeechBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.964 7.988H9.577c-.985 0-1.786.801-1.786 1.785v7.233c0 .985.801 1.782 1.786 1.782h5.943c.132 0 .263.056.357.15l2.953 2.723c.164.16.436.094.436-.136v-2.372c0-.281.178-.37.459-.37h.047c.984 0 1.973-.792 1.973-1.781V9.773a1.778 1.778 0 0 0-1.78-1.785Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.175 6.84h8.316V3.777c0-.844-.685-1.528-1.528-1.528H3.777c-.844 0-1.528.684-1.528 1.528v7.744c0 .844.684 1.528 1.528 1.528h2.864V8.367A1.535 1.535 0 0 1 8.175 6.84Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbles);
export default __webpack_public_path__ + "static/media/speech-bubbles.1786f6e8.svg";
export { ForwardRef as ReactComponent };